<template>
  <div :class="['chat-bubble', isMobile ? '' : 'chat-bubble-pc',moreHeight ? 'more-height':'']" ref="chatBubble">
    <div v-if="bubbleConfig.type === 'normal'" class="chat-list-show-box normal">
      <span
        v-for="(item, index) in bubbleConfig.bubbles"
        :key="index"
        class="list-msg"
        @click="onClickNormal(item)"
      >{{ item.text }}</span>
    </div>
    <div
      v-else-if="bubbleConfig.type === 'robot'"
      class="chat-list-show-box robot"
      :style="'right: ' + right + 'px'"
    >
      <template v-for="(item, index) in bubbleConfig.robotBubbles.menuJson.content.menu.list">
        <message-link
          v-if="item.action === 5"
          :key="index"
          class="list-msg"
          :style="'color:' + bubbleConfig.robotBubbles.color.color"
          :link="{
            url: `qdweb://webim/message/ext2robotsendc2b?content=${textToUnicode(item.name)}&ext=${textToUnicode(JSON.stringify(item))}`,
            text: item.name,
            canClickAgain: true,
          }"
        ></message-link>
        <span
          v-else
          :key="index"
          class="list-msg"
          :style="'color:' + bubbleConfig.robotBubbles.color.color"
          @click="onClickRobot(item)"
        >{{ item.name }}</span>
      </template>
    </div>
    <div
      v-else-if="bubbleConfig.type === 'forHuman'"
      class="chat-list-show-box forHuman"
      :style="'right: ' + right + 'px'"
    >
      <template v-for="(item, index) in bubbleConfig.aioUpBubbles.menuJson.content.menu.list">
        <span
          :key="index"
          class="list-msg"
          :style="'color:' + bubbleConfig.aioUpBubbles.color.color"
          @click="onClickAioUpBubble(item)"
        >{{ item.name }}</span>
      </template>
    </div>

    <div class="right-btn icon-arrow-right" v-show="!isMobile && rightStatus" @click="moveRight"></div>
    <div class="left-btn icon-arrow-left" v-show="!isMobile && leftStatus" @click="moveLeft"></div>
  </div>
</template>

<script>
import handleAction from '@/components/MixinHandleActions.js';
import MessageLink from '@/components/MessageLink';
import globalWin from '@/utils/globalWin';
import { getScrollBottom, scrollLimit } from '@/utils/scroll.ts';
import StringUtils from '@/utils/string';
import { debounce } from '@tencent/qd-lib';
import { handleLinkClick } from '@/utils/bindlLinkClick.js';
import { ACTION_TYPE, REPLY_TYPE } from './common';
import { textToUnicode } from '@/utils/htmlDecode';

/**
 * @component 聊天气泡
 */
let chatListShowBox;
export default {
  name: 'message-bubble',
  mixins: [handleAction],
  inject: ['globalData', 'wpaDetail'],
  props: {
    bubbleConfig: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    MessageLink,
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
    robotTestMode() {
      return globalWin.robotTestMode;
    },
    // 机器人问答测试场景由于滚动条遮挡加一点高度
    moreHeight() {
      return this.isMobile && this.robotTestMode;
    },
  },
  data() {
    return {
      // 气泡类型
      type: 'robot',
      // 右侧距离
      right: 0,
      // 左侧翻页
      leftStatus: false,
      // 右侧翻页
      rightStatus: false,
    };
  },
  mounted() {
    this.initArrow();
    // 这个的处理，要晚于IM窗口的调整
    this.handleResize = debounce(() => {
      this.initArrow();
    }, 200);
    window.addEventListener('resize', this.handleResize);
    if (getScrollBottom() < scrollLimit) {
      globalWin.scrollToBottom();
    }
  },
  beforeDestory() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    /**
     * 点击普通气泡
     */
    onClickNormal(item) {
      handleLinkClick(item.url);
    },

    /**
     * 点击机器人非 发送c2b消息
     */
    onClickRobot(info) {
      this.handleAction(info, {
        robot_nav_id: this.bubbleConfig.robotBubbles.id,
        robot_nav_name: '输入框上方互动导航',
      }, this.globalData.reception.robotId);
    },
    /**
     * 点击人工气泡导航
     */
    onClickAioUpBubble(info) {
      console.log('[onClickAioUpBubble info]', info);

      const action = Number(info.action);
      const path = (info.meta && info.meta.path) || '';

      switch (action) {
        case ACTION_TYPE.ACTION_REPLY:
          // 系统自动回复
          this.handleAioBubbleAction(info);
          break;
        case ACTION_TYPE.ACTION_VISITOR:
          // 访客快速发送
          globalWin.sendTextMessage(StringUtils.coverEmojIndex2EmojiName(info.meta.replyTextHtml));
          this.handleAioBubbleAction(info);
          break;
        case ACTION_TYPE.ACTION_WEB:
          // 跳转网页。
          handleLinkClick(path);
          this.handleAioBubbleAction(info);
          break;
        case ACTION_TYPE.ACTIVE_FEEDBACK:
          // 主动评价
          this.$parent.activeFeedback();
          this.handleAioBubbleAction(info);
          break;
        case ACTION_TYPE.CLOSE_SESSION:
          // 结束会话
          this.$parent.closeSession();
          this.handleAioBubbleAction(info);
          break;
        case ACTION_TYPE.SYSTEM_ACTION:
          this.handleSystemAction(info);
          this.handleAioBubbleAction(info);
          break;
      }
    },
    handleAioBubbleAction(info) {
      const { action } = info;
      const { meta = {} } = info;
      const { replyType } = meta;

      let msgBase;
      const msg = {
        QidianKfUin: this.wpaDetail.kfuin,
        menuName: info.name,
        navId: this?.bubbleConfig?.aioUpBubbles?.id,
      };
      if (action === ACTION_TYPE.ACTION_REPLY) {
        // 系统自动回复
        msgBase = 'mqqwpa://im/qdmenu?version=1&src_type=app&isNeedReply=true';
        msg.replyType = replyType;
        if (replyType === REPLY_TYPE.REPLY_TXT) {
          msg.replyText = meta.replyText;
        } else {
          msg.materialId = meta.materialId;
        }
      } else {
        msgBase = 'mqqwpa://im/qdmenu?version=1&src_type=app&isNeedReply=false';
        // 不需要回复的情况，约定replyType值为22
        msg.replyType = 22;
      }
      const url = `${msgBase}${StringUtils.objToUrlParams(msg)}`;
      console.log('handleAioBubbleAction', url);
      handleLinkClick(url);
    },

    /**
     * @desc 初始化箭头
     */
    initArrow() {
      chatListShowBox = this.$refs?.chatBubble?.querySelector('.chat-list-show-box');
      if (!chatListShowBox) {
        return;
      }
      if (chatListShowBox.scrollWidth > chatListShowBox.clientWidth) {
        this.rightStatus = true;
      } else {
        this.moveRight();
        this.rightStatus = false;
        this.leftStatus = false;
      }
    },

    /**
     * @desc 左侧翻页
     */
    moveLeft() {
      if (!chatListShowBox) {
        return;
      }
      // 如果左侧翻页后，还有内容
      if (chatListShowBox && typeof(chatListShowBox.scrollWidth) !== 'undefined' && chatListShowBox.scrollWidth - this.right <= chatListShowBox.clientWidth) {
        this.leftStatus = true;
        this.rightStatus = true;
        this.right -= chatListShowBox.clientWidth;
        // 超过临界值
        if (this.right < 0) {
          this.leftStatus = false;
          this.right = 0;
        }
      } else {
        this.leftStatus = false;
        this.rightStatus = true;
        this.right = 0;
      }
    },

    /**
     * @desc 右侧翻页
     */
    moveRight() {
      if (!chatListShowBox) {
        return;
      }
      // 如果右侧翻页后，还有内容
      if (chatListShowBox.scrollWidth - chatListShowBox.clientWidth - this.right >= chatListShowBox.clientWidth) {
        this.rightStatus = true;
        this.leftStatus = true;
        this.right += chatListShowBox.clientWidth;
      } else {
        this.rightStatus = false;
        this.leftStatus = true;
        this.right = chatListShowBox.scrollWidth - chatListShowBox.clientWidth;
      }
    },
    /**
     * 系统事件点击
     * @param {*} info
     */
    handleSystemAction(info) {
      console.log('info', info);
      const type = info?.meta?.type;
      if (!type) {
        this.$Toast('暂不支持的type类型');
        return;
      }
      switch (type) {
        // 退出排队
        case 1:
          globalWin.exitQueue();
          break;
        case 2:
          // 结束会话
          this.$parent.closeSession();
          break;
        case 3:
          // 主动评价
          this.$parent.activeFeedback();
          break;
        default:
          this.$Toast('暂不支持的type类型');
          break;
      }
    },
    /**
     * 将字符串中的 & 符转成unicode编码
     */
    textToUnicode(text)  {
      return textToUnicode(text);
    },
  },
};
</script>

<style lang="less" scoped>
.chat-bubble {
  width: 100%;
  height: 40px;
  padding: 6px 6px 6px 12px;
  box-sizing: border-box;
  overflow: auto;
  overflow-y: hidden;
  background: #ecedf1;
  border-bottom: 1px solid #efeff4;

  .chat-list-show-box {
    position: relative;
    white-space: nowrap;
    height: 28px;

    .list-msg {
      display: inline-flex;
      align-items: center;
      text-align: center;
      min-width: 50px;
      padding: 0 12px;
      box-sizing: border-box;
      height: 28px;
      // line-height: 28px;
      font-size: 13px;
      background: #fff;
      color: #78849e;
      border: 1px solid #dadee7;
      border-radius: 20px;
      cursor: pointer;

      &:not(:first-of-type) {
        margin-left: 8px;
      }

      &:active {
        color: rgb(74, 112, 255);
        border-color: rgb(74, 112, 255);
      }
    }
  }
  .left-btn,
  .right-btn {
    position: absolute;
    top: 6px;
    right: 0;
    width: 26px;
    height: 28px;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #c5ccdb;
    cursor: pointer;
    background: #fff;
  }
  .left-btn {
    left: 0;
  }
  .left-btn::before {
    content: "";
    position: absolute;
    top: 9px;
    left: 13px;
    width: 7px;
    height: 7px;
    border-top: 1px solid #c5ccdb;
    border-right: 1px solid #c5ccdb;
    transform: rotate(-135deg);
  }
  .right-btn::before {
    content: "";
    position: absolute;
    top: 9px;
    right: 13px;
    width: 7px;
    height: 7px;
    border-top: 1px solid #c5ccdb;
    border-right: 1px solid #c5ccdb;
    transform: rotate(45deg);
  }
  .left-btn:hover::before,
  .right-btn:hover::before {
    border-color: #a1abc2;
  }
}
.chat-bubble-pc {
  background: #fff;
  display: inline-block;
  position: relative;
  overflow: hidden;
  right: 0;
  border-bottom: 0;
}
.more-height {
  height: 50px;
}
</style>
